import { Component, OnInit, ChangeDetectionStrategy, Inject, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { OrganizationService } from '../organization/organization.service';
import { Organization } from 'src/app/services/organization.model';
import { forkJoin, Observable } from 'rxjs';
import { AuthService } from 'src/app/auth.service';

@Component({
    selector: 'app-create-admin-dialog',
    templateUrl: './create-admin-dialog.component.html',
    styleUrls: ['./create-admin-dialog.component.css'],
    standalone: false
})
export class CreateAdminDialogComponent  implements OnInit {
public userdata: any;
  public userorgdata: any;
  dialogTitle: string;
  organizations: Organization[] = [];
  orgid:string='';
  orgName:string='';
  hasError: boolean = false;
  selectedOrganizationIds: number[] = []; // Define selectedOrganizationIds here
  isPlaceholderVisible: boolean = true;
  showPassword: boolean = false; // Password visibility toggle
  userTypes = [
    { id: 2, label: 'Admin' },
    /*{ id: 2, label: 'Admin' },
    { id: 3, label: 'Analyst' },
    { id: 4, label: 'Operator' }*/
  ];
  role: number; // To hold the user's role
  filteredUserTypes = this.userTypes; // Default to show all options

  statusOptions = [
    { value: 1, label: 'Active' },
    { value: 0, label: 'In-Active' }
  ];

  phonePattern = '^((\\+\\d{1,3}[- ]?)?\\(?\\d{1,4}\\)?[- ]?\\d{1,4}[- ]?\\d{1,4}[- ]?\\d{1,4}|\\(?\\d{3}\\)?[- ]?\\d{3}[- ]?\\d{3})$';
  filteredOrganizations = [];
 
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private organizationService: OrganizationService,
    private cdRef: ChangeDetectorRef,
    private authService: AuthService,
    private dialogRef: MatDialogRef<CreateAdminDialogComponent>
  ) {
    this.dialogTitle = data?.title ?? 'Create Admin';
    this.orgid= data?.organizationId;
    this.orgName=data?.organozationName;
    this.userdata = data?.user ? { ...data.user } : this.initializeEmptyUserData();

   
      this.userdata.organizations = []; // For new users
      this.userdata.organizationsTranctionid=[];
    
    console.log( this.userdata);
  }
   ngOnInit(): void {

     // Set the default value to the first element's id
     if (this.filteredUserTypes.length > 0) {
      this.userdata.userType = this.filteredUserTypes[0].id;
    }

    this.cdRef.detectChanges();
  }


  private initializeEmptyUserData() {
    return {
      userId: '',
      userName: '',
      password: '',
      firstName: '',
      lastName: '',
      emailAddress: '',
      userType: '',
      primaryPhone: '',
      title: '',
      notes: '',
      status: 1,
      organizations: []  // To hold the selected organizations
    };
  }

  togglePlaceholder() {
    this.isPlaceholderVisible = this.userdata.organizations.length === 0;
  }

  onSave(): void {
    // If not in edit mode or no organizations to delete, continue directly with user create or update
    this.createAdminUser();
  
  }

  async createAdminUser(): Promise<void> {
    try {
      // Step 1: Determine whether to update or create the user
      const userResponse = await this.userService.createUser(this.userdata);
  
      // Check if the API response has a status of false (error)
      if (userResponse.status === false) {
        // If status is false, log the error and return early to prevent further actions
        console.error('Error:', userResponse.message);
        
        // Close the dialog with the status and message from the API response
        this.dialogRef.close({
          status: false,
          message: userResponse.message || 'An error occurred during the operation.'
        });
        
        return;  // Exit the function early to prevent further execution
      }
  
      // If no error, log the success message
      //console.log(isEditMode ? 'User updated successfully:' : 'User created successfully:', userResponse);
  
      // Step 2: Proceed to assign user to organizations after successful user creation/update
     
        const userOrgData = {
          userId:  userResponse.id,
          organizationId: this.orgid,
          roleId:this.userdata.userType

        };
  
        try {
          await this.userService.assignOrganization(userOrgData).toPromise();
          console.log(`User assigned to organization ${this.orgid} successfully.`);
        } catch (error) {
          console.error(`Error assigning user to organization ${this.orgid}:`, error);
        }
      
  
      // Step 3: Close the dialog with the success response and message
      this.dialogRef.close({ 
        status: true, 
        user: userResponse,  // Pass the userResponse back when closing the dialog
        message: userResponse.message || 'Operation completed successfully'
      });
  
    } catch (error) {
      
  
      // Step 4: Handle the error by closing the dialog with an error message
      const errorMessage = error?.message || 'An error occurred during the operation.';
      this.dialogRef.close({
        status: false,
        message: errorMessage  // Pass error message from the exception
      });
    }
  }
  


  onCancel(): void {
    this.dialogRef.close();
  }


  loadOrganizations(): void {
    this.organizationService.getOrganizations().subscribe(
      (data: Organization[]) => {
        this.organizations = data;
  
        console.log("org==",this.orgid);
        console.log("org==",this.userdata.organizations );
        if (this.orgid) {
          // If there's a selected ID in localStorage, filter the organizations
          const selectedOrganization = this.organizations.filter(
            org => org.id.toString() === this.orgid
          );
  
          if (selectedOrganization.length > 0) {
            // Set the default selection
            this.userdata.organizations = selectedOrganization.map(org => org.id);
            this.selectedOrganizationIds = [...this.userdata.organizations];
            this.organizations = selectedOrganization;  // Show only the selected organization
          }
        }
  
        // Optionally ensure that the selected organization is reflected in the UI
        this.cdRef.detectChanges(); // Update the view after setting organizations
      },
      (error) => {
        console.error('Error fetching organizations', error);
      }
    );
  }
  
  
  onSelectionChange() {
    // Additional logic if you need to handle anything on selection change
  }
   // Method to toggle password visibility
 togglePasswordVisibility() {
  this.showPassword = !this.showPassword;
}
}